export enum CompanyProfileSection {
  PrimaryInfo = 'primary',
  AdditionalInfo = 'additional',
}
